import { AbstractControl, FormGroup } from '@angular/forms';

/** Récupère un item au hasard dans la liste */
export function getRandomItem<T>(list: T[]): T {
  return list[Math.floor(Math.random() * list.length)];
}

/** Génère un nombre aléatoire entre 0 et le nombre passé en paramètre (exclus) */
export function getRandomNumber(number: number): number {
  return Math.floor(Math.random() * number);
}

/** Génère une date aléatoire entre les deux dates passées en paramètre */
export function getRandomDate(start: Date, end: Date): Date {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

/** Génère une promise qui sera résolue entre 0 et 1 seconde.
 * A utiliser pour mocker une action asynchrone */
export async function randomDelay(): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, getRandomNumber(1000)));
}

export function capitalize(word?: string): string {
  if (!word) return '';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/** Scrolle en haut de l'élément passé en paramètre */
export function scrollTop(element: Element) {
  element?.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
}

/** Met à jour l'état du control et de tous ses enfants */
export function markAsTouched(control: AbstractControl) {
  control.markAllAsTouched();

  if (control instanceof FormGroup) {
    for (const field in control.controls) {
      const nestedControl = control.get(field);
      if (nestedControl) markAsTouched(nestedControl);
    }
  } else {
    control.updateValueAndValidity();
  }
}

/**
 * Ajoute un nombre de jours ouvrés (lundi à vendredi) à une date donnée.
 *
 * Un jour ouvré est considéré comme tout jour de la semaine sauf le samedi (6) et le dimanche (0).
 * Les jours fériés ne sont pas pris en compte dans ce calcul.
 *
 * @param {Date} startDate - La date de départ à partir de laquelle on calcule.
 * @param {number} businessDays - Le nombre de jours ouvrés à ajouter.
 * @returns {Date} Une nouvelle instance de `Date` représentant la date finale après ajout des jours ouvrés.
 */
export function addBusinessDays(startDate: Date, businessDays: number): Date {
  const result = new Date(startDate);
  let addedDays = 0;

  while (addedDays < businessDays) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) {
      addedDays++;
    }
  }

  return result;
}
